import React from 'react';
import { Table, TableBody, TableCell, TableRow, LinearProgress, Typography, Box, TableHead, IconButton, useMediaQuery, useTheme } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import moment from 'moment';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#FFD18E',
  },
}))(LinearProgress);

const useStyles = makeStyles((theme) => ({
  iconCircle: {
    color: '#729762',
    fontSize: 'inherit'
  },
  iconWarning: {
    color: '#E7D37F',
    fontSize: 'inherit'
  },
  tableRowGreen: {
    '&:hover': {
      backgroundColor: '#E0F2E9',
    },
    cursor: 'pointer',
  },
  tableRowYellow: {
    '&:hover': {
      backgroundColor: '#FFF9C4',
    },
    cursor: 'pointer',
  },
  listItem: {
    borderBottom: '1px solid #ddd',
    padding: theme.spacing(2),
  },
  listItemContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  clickableCell: {
    cursor: 'pointer',
  },
}));

const ProductWarrantyInfo = ({ data, onRowClick }) => {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  if (isSmallScreen) {
    return (
      <Box>
        {data.map((row, index) => (
          <Box key={index} className={classes.listItem} onClick={() => onRowClick(row.WarrantyTypeId)}>
            <Box className={classes.listItemContent}>
              <IconButton className={row.Useable ? classes.iconCircle : classes.iconWarning}>
                {row.Useable ? <CheckCircleOutlineIcon /> : <ErrorOutlineIcon />}
              </IconButton>
            </Box>
            <Box className={classes.listItemContent}>
              <Typography variant="body1">{t('lblWarrantyDescription')}:</Typography>
              <Typography variant="body1">{row.WarrantyDescription}</Typography>
            </Box>
            <Box className={classes.listItemContent}>
              <Typography variant="body1">{t('lblStartDate')}:</Typography>
              <Typography variant="body1">{moment(row.StartDate).format('DD.MM.YYYY')}</Typography>
            </Box>
            <Box className={classes.listItemContent}>
              <Typography variant="body1">{t('lblEndDate')}:</Typography>
              <Typography variant="body1">{moment(row.EndDate).format('DD.MM.YYYY')}</Typography>
            </Box>
            <Box className={classes.listItemContent}>
              <Typography variant="body1">{t('lblWarrantyPeriod')}:</Typography>
              <Box width="100%" mr={1}>
                <BorderLinearProgress variant="determinate" value={100} />
              </Box>
              <Typography variant="body2" color="textSecondary">{`${row.TimeDay} day`}</Typography>
            </Box>
            <Box className={classes.listItemContent}>
              <Typography variant="body1">{t('lblRemainingDays')}:</Typography>
              <Box width="100%" mr={1}>
                <BorderLinearProgress
                  variant="determinate"
                  value={row.RemainingDays > row.TimeDay ? 100 : (row.RemainingDays / row.TimeDay) * 100}
                />
              </Box>
              <Typography variant="body2" color="textSecondary">{`${row.RemainingDays} day`}</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell></TableCell>
          <TableCell>{t('lblWarrantyDescription')}</TableCell>
          <TableCell>{t('lblStartDate')}</TableCell>
          <TableCell>{t('lblEndDate')}</TableCell>
          <TableCell>{t('lblWarrantyPeriod')}</TableCell>
          <TableCell>{t('lblRemainingDays')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((row) => (
          <TableRow key={row.WarrantyTypeId} className={row.Useable ? classes.tableRowGreen : classes.tableRowYellow} onClick={() => onRowClick(row.WarrantyTypeId)}>
            <TableCell className={classes.clickableCell}>
              <IconButton className={row.Useable ? classes.iconCircle : classes.iconWarning}>
                {row.Useable ? <CheckCircleOutlineIcon /> : <ErrorOutlineIcon />}
              </IconButton>
            </TableCell>
            <TableCell className={classes.clickableCell}>{row.WarrantyDescription}</TableCell>
            <TableCell className={classes.clickableCell}>{moment(row.StartDate).format('DD.MM.YYYY')}</TableCell>
            <TableCell className={classes.clickableCell}>{moment(row.EndDate).format('DD.MM.YYYY')}</TableCell>
            <TableCell className={classes.clickableCell}>
              <Box display="flex" alignItems="center">
                <Box width="100%" mr={1}>
                  <BorderLinearProgress variant="determinate" value={100} />
                </Box>
                <Typography variant="body2" color="textSecondary">{`${row.TimeDay} day`}</Typography>
              </Box>
            </TableCell>
            <TableCell className={classes.clickableCell}>
              <Box display="flex" alignItems="center">
                <Box width="100%" mr={1}>
                  <BorderLinearProgress
                    variant="determinate"
                    value={row.RemainingDays > row.TimeDay ? 100 : (row.RemainingDays / row.TimeDay) * 100}
                  />
                </Box>
                <Typography variant="body2" color="textSecondary">{`${row.RemainingDays} day`}</Typography>
              </Box>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default ProductWarrantyInfo;
